module.exports = __webpack_public_path__ + "img/1.870a5a63.jpg";